// AUTO-GENERATED - Do not manually edit this file
// This file is generated by scripts/devlink/config-generator/generate-props-config.js
import { FIELD_TYPES } from "../../../../../../constants/template-field-type";
export default {
    agentsTextCodeReviewer: {
        type: FIELD_TYPES.TEXT,
        label: "Agents Text Code Reviewer",
        translatable: true
    },
    agentsTextIncidentResolver: {
        type: FIELD_TYPES.TEXT,
        label: "Agents Text Incident Resolver",
        translatable: true
    },
    agentsTextPmoAgent: {
        type: FIELD_TYPES.TEXT,
        label: "Agents Text Pmo Agent",
        translatable: true
    },
    agentsTextRiskAnalyzer: {
        type: FIELD_TYPES.TEXT,
        label: "Agents Text Risk Analyzer",
        translatable: true
    },
    agentsTextSalesAgent: {
        type: FIELD_TYPES.TEXT,
        label: "Agents Text Sales Agent",
        translatable: true
    },
    agentsTextTranslatorAgent: {
        type: FIELD_TYPES.TEXT,
        label: "Agents Text Translator Agent",
        translatable: true
    },
    buttonSmallText: {
        type: FIELD_TYPES.TEXT,
        label: "Button Small Text",
        translatable: true
    },
    crmTextImportMyContacts: {
        type: FIELD_TYPES.TEXT,
        label: "Crm Text Import My Contacts",
        translatable: true
    },
    crmTextLeadAgent: {
        type: FIELD_TYPES.TEXT,
        label: "Crm Text Lead Agent",
        translatable: true
    },
    crmTextMeetingSummarizer: {
        type: FIELD_TYPES.TEXT,
        label: "Crm Text Meeting Summarizer",
        translatable: true
    },
    crmTextRepPerformanceRanker: {
        type: FIELD_TYPES.TEXT,
        label: "Crm Text Rep Performance Ranker",
        translatable: true
    },
    headingBlack: {
        type: FIELD_TYPES.TEXT,
        label: "Heading Black",
        translatable: true
    },
    headingGradient: {
        type: FIELD_TYPES.TEXT,
        label: "Heading Gradient",
        translatable: true
    },
    itTextIncidentResolver: {
        type: FIELD_TYPES.TEXT,
        label: "It Text Incident Resolver",
        translatable: true
    },
    itTextMonitorSlasAndRisks: {
        type: FIELD_TYPES.TEXT,
        label: "It Text Monitor Slas And Risks",
        translatable: true
    },
    itTextSlaMonitoringAgent: {
        type: FIELD_TYPES.TEXT,
        label: "It Text Sla Monitoring Agent",
        translatable: true
    },
    itTextSummarizeTicketHistory: {
        type: FIELD_TYPES.TEXT,
        label: "It Text Summarize Ticket History",
        translatable: true
    },
    marketingTextCraftCopyForAds: {
        type: FIELD_TYPES.TEXT,
        label: "Marketing Text Craft Copy For Ads",
        translatable: true
    },
    marketingTextGenerateBrandAssets: {
        type: FIELD_TYPES.TEXT,
        label: "Marketing Text Generate Brand Assets",
        translatable: true
    },
    marketingTextRsvpAgent: {
        type: FIELD_TYPES.TEXT,
        label: "Marketing Text Rsvp Agent",
        translatable: true
    },
    marketingTextTranslatorAgent: {
        type: FIELD_TYPES.TEXT,
        label: "Marketing Text Translator Agent",
        translatable: true
    },
    pickerAiAgents: {
        type: FIELD_TYPES.TEXT,
        label: "Picker Ai Agents",
        translatable: true
    },
    pickerAiAppBuilder: {
        type: FIELD_TYPES.TEXT,
        label: "Picker Ai App Builder",
        translatable: true
    },
    pickerAiAssistant: {
        type: FIELD_TYPES.TEXT,
        label: "Picker Ai Assistant",
        translatable: true
    },
    pickerAiWorkflows: {
        type: FIELD_TYPES.TEXT,
        label: "Picker Ai Workflows",
        translatable: true
    },
    pickerButtonText: {
        type: FIELD_TYPES.TEXT,
        label: "Picker Button Text",
        translatable: true
    },
    pickerCrm: {
        type: FIELD_TYPES.TEXT,
        label: "Picker Crm",
        translatable: true
    },
    pickerIt: {
        type: FIELD_TYPES.TEXT,
        label: "Picker It",
        translatable: true
    },
    pickerMarketing: {
        type: FIELD_TYPES.TEXT,
        label: "Picker Marketing",
        translatable: true
    },
    pickerProjectsTasks: {
        type: FIELD_TYPES.TEXT,
        label: "Picker Projects Tasks",
        translatable: true
    },
    pickerSoftware: {
        type: FIELD_TYPES.TEXT,
        label: "Picker Software",
        translatable: true
    },
    primaryButtonText: {
        type: FIELD_TYPES.TEXT,
        label: "Primary Button Text",
        translatable: true
    },
    projectsTextCreateAProjectPlan: {
        type: FIELD_TYPES.TEXT,
        label: "Projects Text Create A Project Plan",
        translatable: true
    },
    projectsTextPmoAgent: {
        type: FIELD_TYPES.TEXT,
        label: "Projects Text Pmo Agent",
        translatable: true
    },
    projectsTextRiskAnalyzer: {
        type: FIELD_TYPES.TEXT,
        label: "Projects Text Risk Analyzer",
        translatable: true
    },
    projectsTextSpotBottlenecks: {
        type: FIELD_TYPES.TEXT,
        label: "Projects Text Spot Bottlenecks",
        translatable: true
    },
    sectionSubtitle: {
        type: FIELD_TYPES.TEXT,
        label: "Section Subtitle",
        translatable: true
    },
    sidekickFloatingAnalyzingData: {
        type: FIELD_TYPES.TEXT,
        label: "Sidekick Floating Analyzing Data",
        translatable: true
    },
    sidekickFloatingBrainstormingIdeas: {
        type: FIELD_TYPES.TEXT,
        label: "Sidekick Floating Brainstorming Ideas",
        translatable: true
    },
    sidekickFloatingCreatingBoard: {
        type: FIELD_TYPES.TEXT,
        label: "Sidekick Floating Creating Board",
        translatable: true
    },
    sidekickFloatingGeneratingImage: {
        type: FIELD_TYPES.TEXT,
        label: "Sidekick Floating Generating Image",
        translatable: true
    },
    sidekickFloatingResearchingOnline: {
        type: FIELD_TYPES.TEXT,
        label: "Sidekick Floating Researching Online",
        translatable: true
    },
    sidekickFloatingWritingDoc: {
        type: FIELD_TYPES.TEXT,
        label: "Sidekick Floating Writing Doc",
        translatable: true
    },
    softwareTextBuildRoadmapPlan: {
        type: FIELD_TYPES.TEXT,
        label: "Software Text Build Roadmap Plan",
        translatable: true
    },
    softwareTextGetRiskSnapshot: {
        type: FIELD_TYPES.TEXT,
        label: "Software Text Get Risk Snapshot",
        translatable: true
    },
    softwareTextPrdAgent: {
        type: FIELD_TYPES.TEXT,
        label: "Software Text Prd Agent",
        translatable: true
    },
    softwareTextSentimentDetector: {
        type: FIELD_TYPES.TEXT,
        label: "Software Text Sentiment Detector",
        translatable: true
    },
    textWhatWouldYouLikeToExplore: {
        type: FIELD_TYPES.TEXT,
        label: "Text What Would You Like To Explore",
        translatable: true
    },
    vibeFloatingBugTracker: {
        type: FIELD_TYPES.TEXT,
        label: "Vibe Floating Bug Tracker",
        translatable: true
    },
    vibeFloatingCommissionCalculator: {
        type: FIELD_TYPES.TEXT,
        label: "Vibe Floating Commission Calculator",
        translatable: true
    },
    vibeFloatingContentCalendar: {
        type: FIELD_TYPES.TEXT,
        label: "Vibe Floating Content Calendar",
        translatable: true
    },
    vibeFloatingEventPlanner: {
        type: FIELD_TYPES.TEXT,
        label: "Vibe Floating Event Planner",
        translatable: true
    },
    vibeFloatingOnboardingFlow: {
        type: FIELD_TYPES.TEXT,
        label: "Vibe Floating Onboarding Flow",
        translatable: true
    },
    vibeFloatingProjectTracker: {
        type: FIELD_TYPES.TEXT,
        label: "Vibe Floating Project Tracker",
        translatable: true
    },
    boardCrmImage: {
        type: FIELD_TYPES.NESTED,
        label: "Board Crm Image",
        fields: {
            src: {
                type: FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    boardDefault: {
        type: FIELD_TYPES.NESTED,
        label: "Board Default",
        fields: {
            src: {
                type: FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    boardItImage: {
        type: FIELD_TYPES.NESTED,
        label: "Board It Image",
        fields: {
            src: {
                type: FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    boardMarketingImage: {
        type: FIELD_TYPES.NESTED,
        label: "Board Marketing Image",
        fields: {
            src: {
                type: FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    boardSoftwareImage: {
        type: FIELD_TYPES.NESTED,
        label: "Board Software Image",
        fields: {
            src: {
                type: FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    crmFloatingImage1: {
        type: FIELD_TYPES.NESTED,
        label: "Crm Floating Image 1",
        fields: {
            src: {
                type: FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    crmFloatingImage2: {
        type: FIELD_TYPES.NESTED,
        label: "Crm Floating Image 2",
        fields: {
            src: {
                type: FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    defaultBoardWidgetFloating1: {
        type: FIELD_TYPES.NESTED,
        label: "Default Board Widget Floating 1",
        fields: {
            src: {
                type: FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    defaultBoardWidgetFloating2: {
        type: FIELD_TYPES.NESTED,
        label: "Default Board Widget Floating 2",
        fields: {
            src: {
                type: FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    itFloatingImage1: {
        type: FIELD_TYPES.NESTED,
        label: "It Floating Image 1",
        fields: {
            src: {
                type: FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    itFloatingImage2: {
        type: FIELD_TYPES.NESTED,
        label: "It Floating Image 2",
        fields: {
            src: {
                type: FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    marketingFloatingImage1: {
        type: FIELD_TYPES.NESTED,
        label: "Marketing Floating Image 1",
        fields: {
            src: {
                type: FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    marketingFloatingImage2: {
        type: FIELD_TYPES.NESTED,
        label: "Marketing Floating Image 2",
        fields: {
            src: {
                type: FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    projectsBoardImage: {
        type: FIELD_TYPES.NESTED,
        label: "Projects Board Image",
        fields: {
            src: {
                type: FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    projectsFloatingImage1: {
        type: FIELD_TYPES.NESTED,
        label: "Projects Floating Image 1",
        fields: {
            src: {
                type: FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    projectsFloatingImage2: {
        type: FIELD_TYPES.NESTED,
        label: "Projects Floating Image 2",
        fields: {
            src: {
                type: FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    softwareFloatingImage1: {
        type: FIELD_TYPES.NESTED,
        label: "Software Floating Image 1",
        fields: {
            src: {
                type: FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    softwareFloatingImage2: {
        type: FIELD_TYPES.NESTED,
        label: "Software Floating Image 2",
        fields: {
            src: {
                type: FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    workflowsFloatingImageLeft: {
        type: FIELD_TYPES.NESTED,
        label: "Workflows Floating Image Left",
        fields: {
            src: {
                type: FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    workflowsFloatingImageRight: {
        type: FIELD_TYPES.NESTED,
        label: "Workflows Floating Image Right",
        fields: {
            src: {
                type: FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    }
};
